import { render, staticRenderFns } from "./ContentDetailWrap.vue?vue&type=template&id=83221684&scoped=true"
import script from "./ContentDetailWrap.vue?vue&type=script&lang=js"
export * from "./ContentDetailWrap.vue?vue&type=script&lang=js"
import style0 from "./ContentDetailWrap.vue?vue&type=style&index=0&id=83221684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83221684",
  null
  
)

export default component.exports